var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    stroke: "#DA291C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.34 46.54H42.54C43.14 46.54 43.32 46.3 43.32 45.7L44.46 19.84C44.46 19.24 44.28 19 43.68 19H37.32C36.66 19 36.42 19.24 36.42 19.84L37.5 45.7C37.5 46.3 37.68 46.54 38.34 46.54ZM40.56 60.16C42.9 60.16 44.94 58.42 44.94 55.78C44.94 53.08 42.96 51.4 40.56 51.4C38.04 51.4 36 53.08 36 55.78C36 58.42 38.04 60.16 40.56 60.16Z",
    fill: "#DA291C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warning-red.79f1d2de2b95b8ba1f1cb7e7bbe9a7a6.svg";
export { ForwardRef as ReactComponent };